import { Component, Input, OnInit } from '@angular/core';
import { FormDomainScriptGuideStatisticsService } from '../../features/statistics/statistics.service';

@Component({
    selector: 'form-domain-script-guide-legacy-statistics',
    standalone: false,
    templateUrl: './statistics.html',
})
export class FormDomainScriptGuideLegacyStatisticsComponent implements OnInit {
    @Input() domain: any;

    show: boolean = false;
    canUse: boolean = false;

    constructor (
        private formDomainScriptGuideStatisticsService: FormDomainScriptGuideStatisticsService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.show = this.formDomainScriptGuideStatisticsService.hasAccessToFeature();
        this.canUse = this.formDomainScriptGuideStatisticsService.getValue();
    }

    onChangeValue () {
        setTimeout(() => {
            this.setValue(this.canUse);
        });
    }

    // PROTECTED
    private setValue (value: boolean) {
        this.formDomainScriptGuideStatisticsService.setValue(value);
    }
}
